import { useEffect, useState } from "react";
import { IInformacionGeneral, getCurrentDateTime, spanishDatePickerStrings } from "../collaboratorCreateView";
import formatearFecha from "../../../../common/formatDate";
import { DatePicker,Icon,TextField,Toggle, TooltipHost} from "@fluentui/react";
import { DateCustom } from "../../../../lib/DateCustom";
import { convertStringToDateProyectoEnalce } from "../../../../common/custom-hooks/TodayDate";
import { t } from "i18next";


export const ProyectoEnlace = ({register,errors,setValue,watch}:IInformacionGeneral) => {

    const [clickPorcent,setClickPorcent] = useState<boolean>(false);
    const [minDateProyect,setMinDateProyect] = useState<Date | undefined>(undefined);
    const [minDateProyectFin,setMinDateProyectFin] = useState<Date | undefined>(undefined);
    const [pageRose,setPageRose] = useState<boolean>(false);
  
    const handleDateChange = (date,name:string) => {
      if(!date)return;
      register(name, { required: false });
      const formattedDate = formatearFecha(date);
      setValue(name,formattedDate); 
    };
  
    const handlerClick = ()=>{
      setClickPorcent(!clickPorcent);
    }

    useEffect(()=>{
  if (pageRose) {
    if(watch("vigencia")){
      const data = convertStringToDateProyectoEnalce(watch("vigencia"));
      setMinDateProyectFin(data);
    }else{
      setMinDateProyectFin(undefined);
    }
  }
    },[watch("vigencia")]);
    
    useEffect(()=>{
      if (pageRose === true) {
        if(watch("fechaingreso")){
        const data = convertStringToDateProyectoEnalce(watch("fechaingreso"));
        setMinDateProyect(data);
      }else{
        setMinDateProyect(undefined)
      }
      }else{  setPageRose(true)}
    },[watch("fechaingreso")])

    useEffect(()=>{
    register("vigencia", {required: clickPorcent});
    setValue("vigencia",""); 
    setValue("fechafin",""); 
    },[clickPorcent])
    return (
    <div className="form_informacion_general">
         <p className="titulo_form_create">
          <Icon iconName="script" style={{fontSize:"25px"}}  />
          {t('Proyecto fijo')}
        </p>
        <div className="cuerpo_izquierdo_form">
          <span className="input_reusable" >
            <Toggle label={t("Pertenece al proyecto fijo")} onClick={handlerClick}/>
          </span>
          <div className="cuerpo_izquierdo_participacion">
             <span className={clickPorcent ?"input_reusable":"input_desaparese"} >
              <TextField 
                key="000345" {...register("participacion",{required:clickPorcent,pattern:/^\d+$/,maxLength:3})}
                label={t("% Participacion")} placeholder={t("Escriba el porcentage")} type="text" 
                styles={{root:{width:"170px"}}} 
              />
              { errors.participacion?.type === "required" && <span className="error_TextFile_proyectofijo" >{t("El % de participación no puede ser vacío.")}</span>}
              { errors.participacion?.type === "pattern" && <span className="error_TextFile_proyectofijo" >{t("Este campo solo permite números.")}</span>}
              { errors.participacion?.type === "maxLength" && <span className="error_TextFile_proyectofijo" >{t("Este campo solo permite tres dígitos.")}</span>}
              
              </span>
            <div className="cuerpo_izquierdo_fechas" style={{display:"flex",flexWrap:"wrap",gap:"5px"}}>
             
              <TooltipHost content={t("Seleccione la fecha de ingreso")}>
               <DatePicker  allowTextInput
               strings={spanishDatePickerStrings}
               formatDate={DateCustom.formatDateForDatePicker}
                placeholder={t("Seleccione la fecha de ingreso")}
                label={t("Vigencia desde")}
                styles={{root:{width:"170px"}}} onSelectDate={(date)=>handleDateChange(date,"vigencia")}
                disabled={!clickPorcent}
                minDate={minDateProyect}
              />
              </TooltipHost>
             
             
              <TooltipHost content={t("Seleccione la fecha de fin")}>
              <DatePicker  allowTextInput
                label={t("Vigencia hasta")}
                strings={spanishDatePickerStrings}
                formatDate={DateCustom.formatDateForDatePicker}
                placeholder={t("Seleccione la fecha de fin")}
                styles={{root:{width:"170px"}}} onSelectDate={(date)=>handleDateChange(date,"fechafin")}
                disabled={!clickPorcent}
                minDate={minDateProyectFin}
              /></TooltipHost>
             
  
            </div>
            { errors.vigencia && <span className="error_stilos_Organizacional">{t('La fecha de ingreso al proyecto no puede ser vacío.')}</span>}
  
          </div>
        </div>
    </div>
  );
  }